import IClientSession from "../interfaces/ClientSession";

export function setClientSessionDates(session:IClientSession) {
	session.issuedAt = new Date(session.issuedAt);
	session.updatedAt = new Date(session.updatedAt);
	session.expiresAt = new Date(session.expiresAt);
	return session;
}